import React from "react";
import {
  AutocompleteArrayInput,
  Edit,
  EditContext,
  FileField,
  FileInput,
  ImageField,
  ImageInput,
  NumberInput,
  RecordContext,
  ReferenceInput,
  SimpleForm,
  TextInput,
} from "react-admin";
import Grid from "@material-ui/core/Grid";
import { countries } from "../../data";

const BrandEdit = (props) => {
  return (
    <Edit title={`Edit Brand`} {...props}>
      <SimpleForm style={{ width: "100%" }}>
        <TextInput source="name" />
        <div style={{ width: "100%" }}>
          <Grid container spacing={2} style={{ width: "100%" }}>
            <Grid item xs={12} sm={6}>
              <AutocompleteArrayInput
                source="countries"
                label="Countries"
                choices={countries}
                optionValue="code"
                optionText="name"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <ReferenceInput
                label="Locations"
                source="places"
                reference="places"
                isRequired
                fullWidth
              >
                <AutocompleteArrayInput
                  source="places"
                  optionValue="id"
                  optionText="name"
                  fullWidth
                  isRequired
                />
              </ReferenceInput>
            </Grid>
          </Grid>
        </div>
        <div style={{ width: "100%" }}>
          <NumberInput source="listingValue" label="Listing Order" fullWidth />
        </div>
        <ImageInput source="brandLogo" label="Brand Logo" accept="image/*">
          <ImageField source="src" title="title" />
        </ImageInput>
      </SimpleForm>
    </Edit>
  );
};

export default BrandEdit;
